/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsWhichIndividualsWereAffectedOptionEnum = {
    Employees: 'Employees',
    Contractors: 'Contractors',
    Customers: 'Customers',
    DataSubjectsGDPR: 'DataSubjectsGDPR',
    Other: 'Other',
} as const;

export type LegalRegulatoryEnumsWhichIndividualsWereAffectedOptionEnumKey =
    (typeof legalRegulatoryEnumsWhichIndividualsWereAffectedOptionEnum)[keyof typeof legalRegulatoryEnumsWhichIndividualsWereAffectedOptionEnum];

export type LegalRegulatoryEnumsWhichIndividualsWereAffectedOption =
    LegalRegulatoryEnumsWhichIndividualsWereAffectedOptionEnumKey;
